import CustomDropdown from "./CustomDropDown";
import { Icon } from 'Components';
import { NavItemConfig, accountItems } from "../Siderbar.constant";
import styles from '../Sidebar.module.scss';
import NavItem from "./NavItem";
import { CurrentUser } from "Services/Api/Auth/Types";
import { useTranslation } from "react-i18next";

type Props = {
    isActiveKey: string,
    collapsed: boolean,
    userDetails: CurrentUser,
    handleItemClick: (item: NavItemConfig) => void
}

const UserRow = ({ userDetails, isActiveKey, collapsed, handleItemClick } : Props) => {
    const { t } = useTranslation();
    const role = userDetails.primarySystemRole.role || '';
    const label = role.includes("superadmin") ? "Administrator" : role.includes("admin") ? "Manager" : "User";
    const roleLabel = t(`sidebar.roles.${label}`);
    return <div className={styles.userRow}>
        {collapsed ? <CustomDropdown {...{ isActiveKey, handleItemClick }} parentClass='account-tile' items={[accountItems[1]]} TitleComp={<NavItem {...{ item: accountItems[0], isActive: isActiveKey === "/profile", isOpen: false, hasChildren: false, onClick: () => handleItemClick(accountItems[0]) }} />}>
            <div className={styles.userRow__avatar} style={{ cursor: "pointer" }}>
                {userDetails.firstName.charAt(0)}
                {userDetails.lastName && userDetails.lastName.charAt(0)}
            </div>
        </CustomDropdown> : <div className={styles.userRow__avatar}>
            {userDetails.firstName.charAt(0)}
            {userDetails.lastName && userDetails.lastName.charAt(0)}
        </div>}
        <div className={styles.userRow__info}>
            <div className={styles.userRow__name}>
                {userDetails.firstName}{' '}
                {userDetails.lastName}
            </div>
            <div className={styles.userRow__role}>
                {roleLabel}
            </div>
        </div>
        <CustomDropdown {...{ isActiveKey, handleItemClick }} parentClass='account-tile' items={[accountItems[1]]} TitleComp={<NavItem {...{ item: accountItems[0], isActive: isActiveKey === "/profile", isOpen: false, hasChildren: false, onClick: () => handleItemClick(accountItems[0]) }} />}>
            <Icon type="optionIcon" role="img" className={styles.userRow__dots} />
        </CustomDropdown>
    </div>
}

export default UserRow;